import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage, auth } from '../config/firebase';
import { logError, logInfo } from './logger';

export const uploadFile = async (file, path, surveyId = null) => {
  try {
    if (!file || !path) {
      throw new Error('File and path are required');
    }

    if (!auth.currentUser) {
      throw new Error('User must be authenticated to upload files');
    }

    // Create clean filename
    const timestamp = Date.now();
    const cleanName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    const filename = `${timestamp}_${cleanName}`;

    // Build the full path based on file type
    let fullPath;
    if (path.includes('high-pole')) {
      if (!surveyId) {
        throw new Error('Survey ID is required for high pole photos');
      }
      fullPath = `surveys/${surveyId}/high-pole-photos/${filename}`;
    } else {
      fullPath = `${path}/${filename}`;
    }

    // Create storage reference
    const storageRef = ref(storage, fullPath);

    // Create metadata
    const metadata = {
      contentType: file.type || 'application/octet-stream',
      customMetadata: {
        uploadedBy: auth.currentUser.uid,
        originalName: file.name,
        timestamp: timestamp.toString(),
        surveyId: surveyId || 'none'
      }
    };

    // Upload file with metadata
    const snapshot = await uploadBytes(storageRef, file, metadata);

    // Get download URL
    const downloadUrl = await getDownloadURL(snapshot.ref);
    logInfo(`File uploaded successfully to ${fullPath}`);
    return downloadUrl;
  } catch (error) {
    logError(`File upload failed for ${path}:`, error);
    throw error;
  }
};

/**
 * Converts a data URL to a File object
 * @param {string} dataUrl - Data URL string
 * @param {string} filename - Desired filename
 * @returns {File} - File object
 */
export const dataURLtoFile = (dataUrl, filename) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, { type: mime });
};